'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _components = require('../../../components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WhiteLabelCrown = require('./WhiteLabelCrown.scss');

var _WhiteLabelCrown2 = _interopRequireDefault(_WhiteLabelCrown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WhiteLabelCrown = function (_PureComponent) {
    (0, _inherits3.default)(WhiteLabelCrown, _PureComponent);

    function WhiteLabelCrown() {
        (0, _classCallCheck3.default)(this, WhiteLabelCrown);
        return (0, _possibleConstructorReturn3.default)(this, (WhiteLabelCrown.__proto__ || (0, _getPrototypeOf2.default)(WhiteLabelCrown)).apply(this, arguments));
    }

    (0, _createClass3.default)(WhiteLabelCrown, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                url = _props.url;


            return (0, _jsx3.default)('div', {
                className: _WhiteLabelCrown2.default.crown
            }, void 0, (0, _jsx3.default)('div', {
                className: _WhiteLabelCrown2.default['crown-inner']
            }, void 0, url.length > 0 && (0, _jsx3.default)(_components.Link, {
                to: url,
                secondary: true
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'return_to',
                values: { name: name }
            }))));
        }
    }]);
    return WhiteLabelCrown;
}(_react.PureComponent);

exports.default = WhiteLabelCrown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/WhiteLabelCrown/WhiteLabelCrown.js
// module id = WcsR
// module chunks = 57